export const modelos =  [
     {nome: "regata", descricao: "regata" }, 
     {nome: "calca", descricao: "calça" }, 
     {nome: "saia_reta", descricao: "saia reta" }
     ];
;
